import RecaptchaButton from "../RecaptchaButton";
import EmailImage from "../../assets/subscribe/mail.svg";
import { useState } from "react";
import { createSubscription } from "../../api";

const SubscribeForm = ({
  content,
  aligns,
  popUpTitle,
  toggleNoti,
  togglePopup,
  onSuccess,
}) => {
  const [subscriber, setSubscriber] = useState({});
  const [isSubscribe, setIsSubscribe] = useState(false);
  const [email, setEmail] = useState("");
  const [isValid, setIsValid] = useState(false);
  const [isRecaptcha, setRecaptcha] = useState(null);

  // EMAIL VALIDATION
  const emailValidation = (e) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const inputEmail = e.target.value;
    setEmail(inputEmail);
    // // Validate email using the regex
    setIsValid(emailRegex.test(inputEmail));
  };

  // CREATE SUBSCRIBE
  const createSubscribe = async () => {
    try {
      const result = await createSubscription(email); // Fetch the data
      setSubscriber(result.data); // Set the posts data in state
      setIsSubscribe(true);
      console.log(result.data);
    } catch (error) {
      console.error("Error fetching posts:", error); // Handle error
    }
  };

  // HANDLE SUBSCRIPTION
  const handleSubscription = (e) => {
    e.preventDefault();

    // INPUT VALIDATION
    if (!isValid) {
      console.log("email invalid");
    } else {
      // TRY SUBSCRIBE
      console.log(popUpTitle?.toUpperCase());
      createSubscribe();
      let url =
        "https://drive.google.com/uc?export=download&id=1DNqW5FDl3fKylDWXBApOKv67O8iNHGtR";
      // IF .. DOWNLOAD
      if (popUpTitle?.toUpperCase().includes("CREDIT")) {
        url =
          "https://drive.google.com/uc?export=download&id=1VWga1TJOONv5jipWjpNbehI525rCWjxi";
      } else if (popUpTitle?.toUpperCase().includes("STOCK")) {
        url =
          "https://drive.google.com/uc?export=download&id=1sKrDH3CWupfW7Bu8ieqeH8YPzuguaOl6";
      } else if (popUpTitle?.toUpperCase().includes("BUDGET")) {
        url =
          "https://drive.google.com/uc?export=download&id=1MKjoBSfTzUpswW43r5Hc7SEHuyngMH_K";
      }
      // window.open(url, "_blank");
      // toggleNoti();
      if (onSuccess) {
        // Landing page behavior
        onSuccess();
      } else {
        // Default behavior (download file)
        window.open(url, "_blank");
        toggleNoti?.();
      }
    }
  };

  switch (aligns) {
    case "center":
      return (
        <form
          className="flex flex-col items-end gap-3 md:w-full"
          onSubmit={handleSubscription}
        >
          <div className="flex flex-row items-center justify-center md:w-full">
            <div className="w-7/12 relative md:h-18 md:w-3/5">
              <img
                src={EmailImage}
                className="absolute inset-y-0 left-2 top-5 w-6 "
              />
              <input
                className="border-black border-2 h-16 text-lg w-full p-2 pl-10 md:h-18 md:w-full"
                placeholder="Email"
                onChange={emailValidation}
                style={{
                  color: isValid ? "black" : "#FF3131",
                  fontStyle: isValid ? "" : "oblique 60deg",
                }}
              ></input>
            </div>
            <button
              type="submit"
              disabled={!isValid || isSubscribe || !isRecaptcha}
              onClick={togglePopup}
              style={
                isSubscribe
                  ? { backgroundColor: "#D9EAD3", color: "#274E13" }
                  : { backgroundColor: "#918e88" }
              }
              className="w-5/12 uppercase border-dark-sec border-0 text-white h-16 px-3 py-1 font-extrabold text-center align-middle text-sm md:text-3xl"
            >
              {isSubscribe ? "YOU'RE IN ✔" : content}
            </button>
          </div>
          {isValid || !email ? (
            <></>
          ) : (
            <p className="m-auto text-red-prim">
              Please enter a valid email (e.g. name@example.com)
            </p>
          )}
          <RecaptchaButton setRecaptcha={setRecaptcha} />
        </form>
      );
    default:
      return (
        <form
          className="flex flex-col items-stretch gap-3 md:w-full"
          onSubmit={handleSubscription}
        >
          <div className="flex md:w-full">
            <div className="relative md:h-18 md:w-3/5">
              <img
                src={EmailImage}
                className="absolute inset-y-0 left-2 top-5 w-6 md:"
              />
              <input
                className="border-black border-2 h-16 text-lg w-full p-2 pl-10 md:h-18 md:w-full"
                placeholder="Email"
                onChange={emailValidation}
                style={{
                  color: isValid ? "black" : "#FF3131",
                  fontStyle: isValid ? "" : "oblique 60deg",
                }}
              ></input>
            </div>
            <button
              type="submit"
              disabled={!isValid || isSubscribe || !isRecaptcha}
              style={
                isSubscribe
                  ? { backgroundColor: "#D9EAD3", color: "#274E13" }
                  : { backgroundColor: "#918e88" }
              }
              className="uppercase border-dark-sec border-0 text-white h-16 px-4 py-1 font-extrabold text-center align-middle text-sm lg:text-3xl"
            >
              {isSubscribe ? "YOU'RE IN ✔" : content}
            </button>
          </div>
          <RecaptchaButton setRecaptcha={setRecaptcha} />
        </form>
      );
  }
};

export default SubscribeForm;
